

export const MCP_HOOK_ORIGIN_RESOLVE = Symbol.for('mcp.hook.originResolve');
